import { EntryProps } from './types';
import { SELECTED_NOTEBOOK_ID } from '../../context/NotebookContext';

export class Entry {
  public authorId: string;
  public content: string;
  public context: string;
  public measurements: {
    subjectId: string;
    trackerId: string;
    value: number;
  }[];
  public notebookId: string;
  public noteId: string | undefined;
  public notedAt: Date;
  public subjectIds: string[];

  public constructor(props: EntryProps) {
    this.authorId = props.authorId;
    this.content = props.content || '';
    this.context = props.context || '';
    this.measurements = props.measurements
      ? props.measurements.map(m => ({
          subjectId: m.subject.id,
          trackerId: m.tracker.id,
          value: m.value
        }))
      : [];
    this.notebookId = localStorage.getItem(SELECTED_NOTEBOOK_ID) as string;
    this.noteId = props.id || undefined;
    this.notedAt = props.notedAt || '';
    this.subjectIds = props.subjects ? props.subjects.map(s => s.id) : [];
  }

  public static newEntry(authorId: string) {
    return new Entry({
      authorId,
      content: '',
      context: '',
      measurements: [],
      notebookId: localStorage.getItem(SELECTED_NOTEBOOK_ID) as string,
      noteId: undefined,
      notedAt: new Date(),
      subjectIds: []
    });
  }
}
